import { request } from '../client';

// Every read here is priced, stocked and filtered for the delivery geography
// the backend resolves from the X-Delivery-* headers. `geographySensitive`
// makes a response that arrives after the browsing location changed reject
// with STALE_DELIVERY_GEOGRAPHY instead of landing as the new location's data.
// `options` passes through to request(), e.g. a pinned `deliveryGeography`
// (a pinned request is never stale).
const catalogRead = (path, options = {}) => request(path, { geographySensitive: true, ...options });

export const listCategories = (options) => catalogRead('/categories', options);

export const listProducts = (params, options = {}) => catalogRead('/products', { ...options, params });

export const getBestOffers = (limit, options = {}) => catalogRead('/products/best-offers', { ...options, params: { limit } });

export const getProduct = (idOrSku, options) => catalogRead(`/products/${encodeURIComponent(idOrSku)}`, options);

export const listActiveSales = (options) => catalogRead('/sales/active', options);
